import { render, staticRenderFns } from "./IndustryPolicy.vue?vue&type=template&id=27656f4f&scoped=true"
import script from "./IndustryPolicy.vue?vue&type=script&lang=js"
export * from "./IndustryPolicy.vue?vue&type=script&lang=js"
import style0 from "./IndustryPolicy.vue?vue&type=style&index=0&id=27656f4f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27656f4f",
  null
  
)

export default component.exports